module.exports = __webpack_public_path__ + "static/media/brown.fdf88caa.png";